import React, { useState } from 'react';

export default function ContactForm({ prefillPart = '', prefillVehicle = '' }) {
  const [form, setForm] = useState({
    name: '', phone: '', email: '',
    type: '', vehicle: prefillVehicle,
    message: prefillPart,
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = 'Name is required';
    if (!form.phone.trim()) errs.phone = 'Phone number is required';
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      setSubmitted(true);
    }, 1000);
  };

  const inputStyle = (field) => ({
    background: 'var(--ice)',
    border: `1.5px solid ${errors[field] ? '#e05252' : 'var(--silver-light)'}`,
    color: 'var(--text-dark)',
    fontFamily: 'Barlow, sans-serif',
    fontSize: '0.95rem',
    padding: '0.8rem 1rem',
    borderRadius: 8,
    width: '100%',
    outline: 'none',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    appearance: 'none',
  });

  if (submitted) {
    return (
      <div style={{
        background: 'rgba(26,138,90,0.08)', border: '1.5px solid #1a8a5a',
        borderRadius: 12, padding: '2.5rem', textAlign: 'center',
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
        <h3 style={{ fontFamily: '"Bebas Neue"', fontSize: '1.8rem', color: 'var(--navy)', letterSpacing: '0.03em', marginBottom: '0.5rem' }}>
          Request Received!
        </h3>
        <p style={{ color: 'var(--text-mid)', fontSize: '1rem', lineHeight: 1.6, marginBottom: '1.5rem' }}>
          Thanks {form.name}! We'll get back to you within 1 business day.<br />
          Or call us directly for faster service.
        </p>
        <a href="tel:5197743338" className="btn-primary">📞 Call (519) 774-3338</a>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }} noValidate>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }} className="form-row-2">
        <div>
          <label className="form-label">Your Name *</label>
          <input value={form.name} onChange={set('name')} placeholder="John Smith" style={inputStyle('name')}
            onFocus={e => { e.target.style.borderColor = 'var(--navy)'; e.target.style.boxShadow = '0 0 0 3px rgba(13,27,42,0.08)'; }}
            onBlur={e => { e.target.style.borderColor = errors.name ? '#e05252' : 'var(--silver-light)'; e.target.style.boxShadow = 'none'; }}
          />
          {errors.name && <p style={{ color: '#e05252', fontSize: '0.78rem', marginTop: '0.25rem' }}>{errors.name}</p>}
        </div>
        <div>
          <label className="form-label">Phone Number *</label>
          <input value={form.phone} onChange={set('phone')} placeholder="(519) 000-0000" type="tel" style={inputStyle('phone')}
            onFocus={e => { e.target.style.borderColor = 'var(--navy)'; e.target.style.boxShadow = '0 0 0 3px rgba(13,27,42,0.08)'; }}
            onBlur={e => { e.target.style.borderColor = errors.phone ? '#e05252' : 'var(--silver-light)'; e.target.style.boxShadow = 'none'; }}
          />
          {errors.phone && <p style={{ color: '#e05252', fontSize: '0.78rem', marginTop: '0.25rem' }}>{errors.phone}</p>}
        </div>
      </div>

      <div>
        <label className="form-label">Email Address</label>
        <input value={form.email} onChange={set('email')} placeholder="you@email.com" type="email" style={inputStyle('email')}
          onFocus={e => { e.target.style.borderColor = 'var(--navy)'; e.target.style.boxShadow = '0 0 0 3px rgba(13,27,42,0.08)'; }}
          onBlur={e => { e.target.style.borderColor = 'var(--silver-light)'; e.target.style.boxShadow = 'none'; }}
        />
      </div>

      <div>
        <label className="form-label">Inquiry Type</label>
        <select value={form.type} onChange={set('type')} style={inputStyle('type')}
          onFocus={e => { e.target.style.borderColor = 'var(--navy)'; e.target.style.boxShadow = '0 0 0 3px rgba(13,27,42,0.08)'; }}
          onBlur={e => { e.target.style.borderColor = 'var(--silver-light)'; e.target.style.boxShadow = 'none'; }}
        >
          <option value="">Select inquiry type...</option>
          <option>Part Request</option>
          <option>Scrap Car Removal</option>
          <option>General Question</option>
          <option>Parts Pricing</option>
          <option>Parts Locator Service</option>
        </select>
      </div>

      <div>
        <label className="form-label">Vehicle (Year, Make, Model)</label>
        <input value={form.vehicle} onChange={set('vehicle')} placeholder="e.g. 2018 Honda Civic" style={inputStyle('vehicle')}
          onFocus={e => { e.target.style.borderColor = 'var(--navy)'; e.target.style.boxShadow = '0 0 0 3px rgba(13,27,42,0.08)'; }}
          onBlur={e => { e.target.style.borderColor = 'var(--silver-light)'; e.target.style.boxShadow = 'none'; }}
        />
      </div>

      <div>
        <label className="form-label">Part Needed or Message</label>
        <textarea value={form.message} onChange={set('message')}
          placeholder="e.g. Passenger front door, black — 2018 Honda Civic. Any condition considered."
          rows={4}
          style={{ ...inputStyle('message'), resize: 'vertical', minHeight: 110 }}
          onFocus={e => { e.target.style.borderColor = 'var(--navy)'; e.target.style.boxShadow = '0 0 0 3px rgba(13,27,42,0.08)'; }}
          onBlur={e => { e.target.style.borderColor = 'var(--silver-light)'; e.target.style.boxShadow = 'none'; }}
        />
      </div>

      <button type="submit" className="btn-primary" style={{ justifyContent: 'center', opacity: submitting ? 0.7 : 1 }} disabled={submitting}>
        {submitting ? '⏳ Sending...' : '📤 Send Request →'}
      </button>

      <p style={{ fontSize: '0.78rem', color: 'var(--text-light)', textAlign: 'center' }}>
        Or call us directly at <a href="tel:5197743338" style={{ color: 'var(--orange)', textDecoration: 'none' }}>(519) 774-3338</a> for immediate assistance.
      </p>

      <style>{`@media (max-width: 600px) { .form-row-2 { grid-template-columns: 1fr !important; } }`}</style>
    </form>
  );
}
